import React from 'react';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import MailIcon from '@material-ui/icons/Mail';
import "./css/footer.css";

function Footer() {
    return (
        <div id="footer" className="footer">

            {/* ********* CONTACT NUMBER **********/}

            <div className="footer_left">
                <p>© {new Date().getFullYear()} RISHI - All Rights Reserved</p>
                <p><a href="mailto:rishiagrawal0405@gmail.com">rishiagrawal0405@gmail.com</a></p>
                <p>+91 7597649518</p>
            </div>
            <div className="footer_mid">
                <a href="/about">About Us</a>
                <a href="/about/#about_shipping">Payment & Shipping Policy</a>
                <a href="/about/#about_shipping">FAQ</a>
                <a href="/about/#refund">Refund Policy</a>
            </div>
            <div className="footer_right">
                <div className="footer_icons"><a href="https://www.facebook.com/rishi.agarawal.568"><FacebookIcon fontSize="large" /></a></div>
                {/* MAIL ID */}
                <div className="footer_icons"><a href="mailto:rishiagrawal0405@gmail.com"><MailIcon fontSize="large" /></a></div>
                <div className="footer_icons"><a href="https://www.instagram.com/"><InstagramIcon fontSize="large" /></a></div>
            </div>
        </div>
    )
}

export default Footer
